import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
const b = bemClassBuilder('v-seat-picker-row-label');
export const SeatPickerRowLabel = observer(props => {
    const { rectangle, label, borderRadius, borderWidth } = props;
    const { x, y, width, height } = rectangle;
    return (_jsxs("g", { className: b.block(), transform: `translate(${x}, ${y})`, children: [_jsx("rect", { className: b.element('background'), x: 0, y: 0, width: width, height: height, rx: borderRadius, strokeWidth: borderWidth }), _jsx("text", { className: b.element('text'), x: width / 2, y: height / 2, dominantBaseline: "central", alignmentBaseline: "central", textAnchor: "middle", children: label })] }));
});
SeatPickerRowLabel.displayName = 'SeatPickerRowLabel';
//# sourceMappingURL=row-label.js.map